<template>
  <div>
    <div class="page-title">New Schema</div>
    <Form v-if="form" v-model="form" :submit="create" btnText="Add Schema" />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.applications.page";
export default {
  components: { Form },
  metaInfo() {
    return {
      title: "New Schema",
    };
  },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.GreenhouseApplication.new();
      this.form = data;
    },
    async create() {
      await this.$api.GreenhouseApplication.create(this.form);
      this.$router.push("/greenhouse/applications");
    },
  },
};
</script>

<style></style>
